import { LoggerService } from '@anecdotes/design-system/helpers';
import { Component, ElementRef, Input, OnInit, Optional, inject, DestroyRef } from '@angular/core';
import { BehaviorSubject, combineLatest, } from 'rxjs';
import { SvgRegistryService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg-icon',
  template: '',
  styleUrls: ['./svg-icon.component.scss'],
  standalone: false,
})
export class SvgIconComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private srcChange = new BehaviorSubject<string>(null);

  @Input()
  set src(value: string) {
    this.srcChange.next(value);
  }

  @Input()
  stretch: boolean;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Optional() private svgRegistry: SvgRegistryService,
    @Optional() private logger: LoggerService
  ) { }

  ngOnInit(): void {
    // so that we can use svg icon components in tests without loading svg assets
    if (!this.svgRegistry) {
      return;
    }

    combineLatest([this.srcChange, this.svgRegistry.isReadyState$()])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([src, isReady]) => {
        this.elementRef.nativeElement.innerHTML = null;

        if (isReady && src) {
          this.appendSvg(src);
        }
      });
  }

  private appendSvg(src: string): void {
    if (src) {
      try {
        const svg = this.svgRegistry.getRequiredSvgElement(src);
        this.elementRef.nativeElement.appendChild(svg);
      } catch (error) {
        this.logger.error(error);
      }
    }
  }
}
